import { render, staticRenderFns } from "./TodaySummary.vue?vue&type=template&id=47a98a78"
import script from "./TodaySummary.vue?vue&type=script&lang=js"
export * from "./TodaySummary.vue?vue&type=script&lang=js"
import style0 from "./TodaySummary.vue?vue&type=style&index=0&id=47a98a78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports